import _set from 'lodash.set';

const buildErrorMessage = (intl, error) => {
  const errorMessageDescriptor = error.message?.messageDescriptor;
  const errorMessageValues = error.message?.values || {};
  const tooltipMessageDescriptor = error.message?.tooltipDescriptor;
  const message = errorMessageDescriptor ? intl.formatMessage(errorMessageDescriptor, errorMessageValues) : error.message;
  const tooltip = tooltipMessageDescriptor && intl.formatMessage(tooltipMessageDescriptor);
  return {
    message,
    tooltip,
  };
};

export const errorHandler = (intl, validationError) => {
  return (
    validationError?.inner?.reduce((aggErrors, error) => {
      _set(aggErrors, error.path, {
        ...error,
        ...buildErrorMessage(intl, error),
      });
      return aggErrors;
    }, {}) || {}
  );
};

export const buildMessageCallback = (messageDescriptor, rest) => () => ({
  ...rest,
  messageDescriptor,
});
